import React, {useEffect, useState} from 'react'

import dynamic from 'next/dynamic'
import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {useRouter} from 'next/router'
import {SearchResponse} from '@algolia/client-search'
import {default as searchInsights} from 'search-insights'

import {useEvents} from '@festi/common/contexts'
import {VariantList} from '@festi/common/api/rest'
import {recommendIndexName} from '@festi/common/api/recommend'
import useTagmanager, {
  sendEcommerceItemListEvent,
} from '@festi/common/utils/tagmanager'

import {AdditionalProductCard} from '../cards'
import {ProductAttributeLabel} from './ProductAttributeWrapper'

const CustomSlider = dynamic(import('../common/CustomSlider'), {ssr: false})

const RelatedSlider = styled.div`
  padding: 16px 0px;
  overflow: visible;
  border-top: 1px solid ${palette('ui10Solid')};

  ${media.sm`
    overflow: hidden;
  `}

  .slick-list> div {
    margin-left: 0;
  }
`

interface Props {
  list: 'AR Related Products' | 'AR Bought Together'
  title: string
  variants: SearchResponse<VariantList>
}

export default function ProductRelated({list, title, variants}: Props) {
  const {asPath} = useRouter()
  const {userToken} = useEvents()
  const {sendEcommerceClickEvent} = useTagmanager()

  const [viewed, setViewed] = useState('')

  const firstSixProducts = variants?.hits?.slice(0, 6)

  const hasProducts = !!firstSixProducts?.length
  const triggerAnalytics = hasProducts && (viewed === '' || viewed !== asPath)

  useEffect(() => {
    if (triggerAnalytics) {
      setViewed(asPath)
      sendEcommerceItemListEvent(firstSixProducts, list)
    }
  }, [list, asPath, firstSixProducts, triggerAnalytics])

  if (!variants?.hits?.length) return null

  return (
    <RelatedSlider>
      <CustomSlider
        title={<ProductAttributeLabel>{title}</ProductAttributeLabel>}
        xl={3}
        lg={2.2}
        md={1.5}
        sm={1.5}
        small
      >
        {firstSixProducts?.map((variant: VariantList, index) => (
          <AdditionalProductCard
            key={variant.sku}
            origin={list}
            variant={variant}
            onClick={() => {
              sendEcommerceClickEvent(variant, index + 1, list)
            }}
            searchInsights={() => {
              searchInsights('clickedObjectIDsAfterSearch', {
                eventName: list,
                index: recommendIndexName,
                objectIDs: [variant.sku],
                positions: [index + 1],
                queryID: variants?.queryID,
                userToken,
              })
            }}
            keepSm
          />
        ))}
      </CustomSlider>
    </RelatedSlider>
  )
}
